import { Link } from "@freightsimple/ui-core/Typography/Link";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";

interface HandlingUnitsQuestionBubbleProps {
  onAddLineItem: (() => void) | undefined;
}

const LineItemsHandlingUnitsQuestionBubble: React.FC<
  HandlingUnitsQuestionBubbleProps
> = (props: HandlingUnitsQuestionBubbleProps) => {
  return (
    <Tooltip
      interactive
      variant="info"
      content={
        <Stack gap={2}>
          <T weight="bold">Handling Units</T>
          <T size="xs" color="secondary">
            Select how many of the same sized handling units you have.
          </T>
          {props.onAddLineItem && (
            <T size="xs" color="secondary">
              If you have multiple of the same type of handling unit, but with
              different dimensions, please add an additional row for each one.
            </T>
          )}
          <Link
            href="https://help.freightsimple.com/using-freightsimple/quoting/shipment-contents#handling-units"
            external
          >
            Learn more
          </Link>
        </Stack>
      }
    />
  );
};
export default LineItemsHandlingUnitsQuestionBubble;
